import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {NavLink, withRouter} from 'react-router-dom';
import Util from '../../forecast-app/shared/util/util';
import {MODULE_TYPES, TIERS} from '../../constants';
import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';
import {findResourceSubPage} from './SettingsResourcesSubNav';
import {hasModule} from '../../forecast-app/shared/util/ModuleUtil';

class SettingsSection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shouldRender: true,
		};
	}

	UNSAFE_componentWillMount() {
		this.validateAccess();
	}

	validateAccess() {
		const path = this.props.history.location.pathname;
		if (!Util.AuthorizeViewerAccess('settings')) {
			if (Util.pathIncludesTask(path)) {
				this.setState({shouldRender: false});
				const cardPath = path.substring(Util.indexOfTask(path), path.length);
				this.props.history.push('/' + cardPath);
			} else {
				// if user doesnt have access rights to view this page redirect to no access page
				this.props.history.push('/not-authorized');
			}
		}
	}

	getActiveIndicator() {
		return (
			<div className="active-indicator">
				<div className="border" />
			</div>
		);
	}

	sectionV2(viewer, navLinkBase, formatMessage, showSubscription) {
		const hasFinancial = Util.hasFinance(viewer.company.modules);
		const hasDepartments = Util.hasDepartments(viewer.company.modules);
		const hasSkillsFeature = hasFeatureFlag('skills');
		const noTimeReg = hasFeatureFlag('no_time_reg');

		return (
			<div className=" settings-section-header ">
				<nav className=" section-navigation old">
					<ul>
						<li data-cy={'settings-header-nav-point-details'}>
							<NavLink to={`${navLinkBase}/details`} className="details" activeClassName={'active'}>
								<span title={formatMessage({id: 'common.details'})}>
									{formatMessage({id: 'common.details'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
						{hasSkillsFeature && (
							<li data-cy={'settings-header-nav-point-resources'}>
								<NavLink
									to={`${navLinkBase}/people`}
									isActive={(match, location) => findResourceSubPage(location.pathname)}
									className="resources"
									activeClassName="active"
									data-userpilot="settings-header-resources"
								>
									<span title={formatMessage({id: 'settings.resources'})}>
										{formatMessage({id: 'settings.resources'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						{!hasSkillsFeature && (
							<>
								<li data-cy={'settings-header-nav-point-roles'}>
									<NavLink
										to={`${navLinkBase}/roles`}
										className="roles"
										activeClassName={'active'}
										data-userpilot={'settings-header-roles'}
									>
										<span title={formatMessage({id: 'settings.roles'})}>
											{formatMessage({id: 'settings.roles'})}
										</span>
										{this.getActiveIndicator()}
									</NavLink>
								</li>
								<li data-cy={'settings-header-nav-point-people'}>
									<NavLink
										to={`${navLinkBase}/people`}
										data-cy="people-details"
										activeClassName={this.state.hoveringSectionLink ? '' : 'active'}
										data-userpilot={'settings-header-people'}
									>
										<span title={formatMessage({id: 'common.people'})}>
											{formatMessage({id: 'common.people'})}
										</span>
										{this.getActiveIndicator()}
									</NavLink>
								</li>
							</>
						)}
						{hasModule(MODULE_TYPES.PERMISSION_MANAGEMENT) && (
							<li data-cy={'settings-header-nav-point'}>
								<NavLink
									to={`${navLinkBase}/permissions`}
									className="permissions"
									activeClassName="active"
									data-userpilot="settings-header-permissions"
								>
									<span title={formatMessage({id: 'common.permissions'})}>
										{formatMessage({id: 'common.permissions'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						{!hasSkillsFeature && (
							<li data-cy={'settings-header-nav-point-teams'}>
								<NavLink
									to={`${navLinkBase}/teams`}
									activeClassName={this.state.hoveringSectionLink ? '' : 'active'}
								>
									<span title={formatMessage({id: 'settings.teams'})}>
										{formatMessage({id: 'settings.teams'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						{hasDepartments && !hasSkillsFeature && (
							<li data-cy={'settings-header-nav-point-departments'}>
								<NavLink
									to={`${navLinkBase}/departments`}
									activeClassName={this.state.hoveringSectionLink ? '' : 'active'}
								>
									<span title={formatMessage({id: 'common.departments'})}>
										{formatMessage({id: 'common.departments'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						{hasFinancial ? (
							<li data-cy={'settings-header-nav-point-finance'}>
								<NavLink
									to={`${navLinkBase}/finance`}
									data-userpilot="finance-navigation"
									activeClassName={this.state.hoveringSectionLink ? '' : 'active'}
								>
									<span title={formatMessage({id: 'settings_finance.menuTitle'})}>
										{formatMessage({id: 'settings_finance.menuTitle'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						<li data-cy={'settings-header-nav-point-team-notifications'}>
							<NavLink
								to={`${navLinkBase}/team-notifications`}
								className="notifications"
								activeClassName={'active'}
							>
								<span title={formatMessage({id: 'header.notifications'})}>
									{formatMessage({id: 'header.notifications'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
						<li data-cy={'settings-header-nav-point-labels'}>
							<NavLink
								to={`${navLinkBase}/labels`}
								className="labels"
								activeClassName={this.state.hoveringSectionLink ? '' : 'active'}
							>
								<span title={formatMessage({id: 'settings_labels.labels'})}>
									{formatMessage({id: 'settings_labels.labels'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
						{!noTimeReg && (
							<li data-cy={'settings-header-nav-point-idle-times'}>
								<NavLink
									to={`${navLinkBase}/idle-times`}
									className="non-project-time"
									activeClassName={'active'}
									data-userpilot={'settings-header-idle-times'}
								>
									<span title={formatMessage({id: 'common.time_management'})}>
										{formatMessage({id: 'common.time_management'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						<li data-cy={'settings-header-nav-point-holiday-calendars'}>
							<NavLink
								to={`${navLinkBase}/holiday-calendars`}
								className="holiday-calendars"
								activeClassName={'active'}
							>
								<span title={formatMessage({id: 'common.holidays'})}>
									{formatMessage({id: 'common.holidays'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
						{showSubscription ? (
							<li>
								<NavLink to={`${navLinkBase}/subscription`} className="subscription" activeClassName={'active'}>
									<span title={formatMessage({id: 'settings.subscription'})}>
										{formatMessage({id: 'settings.subscription'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{
							<li data-cy={'settings-header-nav-point-clients'}>
								<NavLink
									to={`${navLinkBase}/clients`}
									className={
										this.props.location.pathname.includes('clients') && !this.state.hoveringSectionLink
											? 'clients active'
											: 'clients'
									}
									activeClassName={'active'}
								>
									<span title={formatMessage({id: 'settings.clients'})}>
										{formatMessage({id: 'settings.clients'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						}
						<li data-cy={'settings-header-nav-point-api-keys'}>
							<NavLink to={`${navLinkBase}/api-keys`} className="keys" activeClassName={'active'}>
								<span title={formatMessage({id: 'settings.api_keys.title'})}>
									{formatMessage({id: 'settings.api_keys.title'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
						<li data-cy={'settings-header-nav-point-integrations'}>
							<NavLink
								to={`${navLinkBase}/catalog`}
								className={
									this.props.location.pathname.includes('catalog') && !this.state.hoveringSectionLink
										? 'catalog active'
										: 'catalog'
								}
								activeClassName={'active'}
							>
								<span title={formatMessage({id: 'settings_account.section-integrations'})}>
									{formatMessage({id: 'settings_account.section-integrations'})}
								</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
				</nav>
			</div>
		);
	}

	render() {
		if (!this.state.shouldRender) return <div />;
		const {viewer} = this.props;
		const navLinkBase = `/settings`;
		const {formatMessage} = this.props.intl;

		const showSubscription =
			[TIERS.LITE, TIERS.PRO, TIERS.ENTERPRISE].includes(viewer.company.tier) && viewer.company.isChargebeeCustomer;

		return (
			<section className="app-main settings-section header">
				<div className={'section-main v2 ' + (window.location.href.includes('/subscription') ? ' white admin' : '')}>
					{this.sectionV2(viewer, navLinkBase, formatMessage, showSubscription)}
				</div>
			</section>
		);
	}
}

SettingsSection.propTypes = {};

export default injectIntl(withRouter(SettingsSection));
